common.View.create('crud::form.inputs.Datetime', {

    /**
     * Called when DOM is ready.
     */
    onDOMLoad()
    {
        this.initGUI();
    },

    /**
     * Initializes the Datetime picker.
     */
    initGUI()
    {
        this.element

            .find('input')
            .flatpickr({
                locale: 'nl',
                "dateFormat": "d-m-Y H:i",

                "enableTime": true,
                "time_24hr": true,
                allowInput: !$(this.element).is('[disabled]'),
            });
    },

});
